import types from '../types/types';

const initialState = {
  referralId: null,
  referralName: null,
};
const referralFromURLReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.referralFromUrl:
      return {
        ...state,
        referralId: action.referralId,
        referralName: action.referralName,
      };

    default:
      return state;
  }
};
export default referralFromURLReducer;
